module.exports = __webpack_public_path__ + "img/message.2c2b9f69.svg";